import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../../select/eager-select/eager-select-reducer';
import { filterExtensionOption } from '../../../select/shared/filter-extension-option';
import { extensionLoadAutoAttendantsActions } from '../extension-option.actions';

export const extensionAutoAttendantOptionFeatureKey = 'extensionAutoAttendantOptions';

export type ExtensionAutoAttendantOptionState = EagerSelectState<ExtensionOption>;

const autoAttendantAdapter = createEagerSelectAdapter<ExtensionAutoAttendantOptionState, ExtensionOption>({
   featureKey: extensionAutoAttendantOptionFeatureKey,
   selectId: (extension: ExtensionOption) => {
      return extension.extensionId;
   },
});

export const extensionAutoAttendantOptionSelectors = autoAttendantAdapter.getSelectors(filterExtensionOption);

const initialAutoAttendantState = autoAttendantAdapter.getInitialState();

export const extensionAutoAttendantOptionsReducer = createEagerSelectReducer(
   autoAttendantAdapter,
   initialAutoAttendantState,
   extensionLoadAutoAttendantsActions.search,
   extensionLoadAutoAttendantsActions.searchReset,
   extensionLoadAutoAttendantsActions.loadFromApi,
   extensionLoadAutoAttendantsActions.loadFromApiSuccess,
   extensionLoadAutoAttendantsActions.loadFromApiFailure,
   null
);
